import "../pages.scss"
import { ModelosState } from '../../context/modelos/ModelosState';
import Datatable from "./modelosTable/Datatable"

const ModelosPage = () => {
  return (
    <>
      <ModelosState>
        <Datatable />
      </ModelosState>
    </>
  )
}

export default ModelosPage